import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Env, ENV_TOKEN } from './edgvr-portal-feature-env.token';

@NgModule({
  imports: [CommonModule],
})
export class EdgvrPortalFeatureEnvModule {
  static forRoot(env: Env): ModuleWithProviders<EdgvrPortalFeatureEnvModule> {
    return {
      ngModule: EdgvrPortalFeatureEnvModule,
      providers: [
        {
          provide: ENV_TOKEN,
          useValue: env,
        },
      ],
    };
  }
}
